module.exports = __webpack_public_path__ + "img/image-placeholder.c6ee7f23.svg";